import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import type { Options as ReactRendererOptions } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

const createContentRenderer =
  ({ renderNode, renderMark, renderText }: ReactRendererOptions) =>
  (content: Document) => {
    return documentToReactComponents(content, {
      renderNode,
      renderMark,
      renderText,
    });
  };

// In French, we put a space before ?, !, :, and ;.
// By replacing space with NBSP, we can prevent unwanted line breaks between a word and the following punctuation mark.
const replaceSpaceBeforePunctuationsWithNBSP = (text: string) => text.replace(/ ([!?:;])/g, ' $1');

export { createContentRenderer, replaceSpaceBeforePunctuationsWithNBSP };
